import { useEffect, useState } from "react";
import { useProfileContext } from "@/providers/profile-provider/profile-provider";

const useEditCustom = (initialVoiceName: string) => {
  const { license } = useProfileContext();

  const [name, setName] = useState<string>(initialVoiceName);
  const [newCover, setNewCover] = useState<File | undefined>(undefined);
  const [makePublic, setMakePublic] = useState<boolean | undefined>(undefined);
  const [isPrivacyEditingAllowed, setIsPrivacyEditingAllowed] = useState(true);
  const [saveLoading, setSaveLoading] = useState<boolean>(false);

  const saveChanges = async (modelId: string) => {
    try {
      if (saveLoading) {
        return;
      }

      const form = new FormData();
      form.append("modelId", modelId);
      form.append("newName", name);
      form.append("oldName", initialVoiceName);

      if (newCover) {
        form.append("thumbnail", newCover);
      }

      if (makePublic) {
        form.append("policy", makePublic ? "Public" : "Private");
      }

      setSaveLoading(true);
      await fetch("/api/train/update", {
        method: "POST",
        body: form,
      });
    } catch (e) {
      console.log("Update error");
    } finally {
      setSaveLoading(false);
    }
  };

  useEffect(() => {
    setIsPrivacyEditingAllowed(license !== "Trial");
  }, [license]);

  return {
    name,
    setName,
    newCover,
    saveLoading,
    setNewCover,
    makePublic,
    isPrivacyEditingAllowed,
    setMakePublic,
    saveChanges,
  };
};

export default useEditCustom;
